import axiosInstance from '../../../../config/axiosInstance';
//import FormPermissionService from "../SetupService/FormPermissionService/FormPermissionService";
import FormPermissionService from "../../../Setup/controller/FormController/FormController";
const SACompanyListService = {
    async GetAllCompanies(redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/GetAllCompanies`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async GetCompanyByID(redirectCallback, ID) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/GetCompanyByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async DeleteClient(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/DeleteCompany?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetActiveClient(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/ActiveCompanyRecord?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async ForgetPassword(Email) {
        try {

            const response = await axiosInstance.get(`/Auth/ForgetPassword?Email=${Email}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DownloadBackup() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            //   const response = await axiosInstance.get(`/SuperAdmin/GetDbBackup?ClientID=${ClientID}`);
            const response = await axiosInstance.get(`/SuperAdmin/GetDbBackup?ClientID=${ClientID}&UserID=${UserID}`, {
                responseType: 'blob', // ✅ Important!
            });

            return response;

        } catch (error) {
            console.error('Error downloading backup:', error);
            throw error;
        }
    },
    async DownloadDatabaseBackup() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            //   const response = await axiosInstance.get(`/SuperAdmin/GetDbBackup?ClientID=${ClientID}`);
            const response = await axiosInstance.get(`/SuperAdmin/DownloadBackup?ClientID=${ClientID}&UserID=${UserID}`);
            return response.data;

        } catch (error) {
            console.error('Error downloading backup:', error);
            throw error;
        }
    },
    async RestoreDatabaseBackup(selectedFile) {
        try {
            debugger;
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const formDataToSend = new FormData();
            formDataToSend.append('ID', 123); // your backup record ID, replace with real ID
            formDataToSend.append('dbName', 'sam5'); // replace with real DB name
            formDataToSend.append('filePath', selectedFile.name); // server will reconstruct full path
            formDataToSend.append('file', selectedFile);
            formDataToSend.append('ClientID', ClientID);
            formDataToSend.append('UserID', UserID);
            for (let [key, value] of formDataToSend.entries()) {
                console.log(key, value);
            }
            debugger;
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const response = await axiosInstance.post(
                `/SuperAdmin/RestoreDbBackup?ClientID=${ClientID}&UserID=${UserID}`,
                formDataToSend,
                config
            );

            debugger;
            return response.data;

        } catch (error) {
            console.error('Error downloading backup:', error);
            throw error;
        }
    }

};

export default SACompanyListService;